import React from "react";
import { fonts, scoreColor } from "../theme";

export default function TrustDial({ score = 650, size = 180, theme, label = "TRUST SCORE", max = 900 }) {
  const min = 300;
  const pct = Math.max(0, Math.min(1, (score - min) / (max - min)));
  const startAngle = -130, endAngle = 130;
  const angle = startAngle + pct * (endAngle - startAngle);
  const r = size / 2 - 10;
  const cx = size / 2, cy = size / 2;

  const toXY = (deg, radius) => {
    const rad = (deg - 90) * (Math.PI / 180);
    return [cx + radius * Math.cos(rad), cy + radius * Math.sin(rad)];
  };

  const ticks = [];
  for (let i = 0; i <= 12; i++) {
    const deg = startAngle + (i / 12) * (endAngle - startAngle);
    const [x1, y1] = toXY(deg, r);
    const [x2, y2] = toXY(deg, r - (i % 3 === 0 ? 8 : 4));
    ticks.push(<line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke={theme.line} strokeWidth={i % 3 === 0 ? 1.5 : 1} />);
  }

  const [nx, ny] = toXY(angle, r - 12);
  const color = scoreColor(score, theme);

  const arcPath = (from, to, radius) => {
    const [x1, y1] = toXY(from, radius);
    const [x2, y2] = toXY(to, radius);
    const large = to - from > 180 ? 1 : 0;
    return `M ${x1} ${y1} A ${radius} ${radius} 0 ${large} 1 ${x2} ${y2}`;
  };

  const numFontSize = Math.max(16, Math.round(size * 0.18));
  const lblFontSize = Math.max(8, Math.round(size * 0.065));

  return (
    <div style={{ width: size, height: size, position: "relative", margin: "0 auto" }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle cx={cx} cy={cy} r={r + 6} fill="none" stroke={theme.line} strokeWidth={1} strokeDasharray="2 4" />
        <path d={arcPath(startAngle, endAngle, r)} fill="none" stroke={theme.line} strokeWidth={3} />
        <path d={arcPath(startAngle, angle, r)} fill="none" stroke={color} strokeWidth={3} strokeLinecap="round" />
        {ticks}
        <line x1={cx} y1={cy} x2={nx} y2={ny} stroke={color} strokeWidth={2} strokeLinecap="round" />
        <circle cx={cx} cy={cy} r={3.5} fill={color} />
      </svg>
      <div style={{ position: "absolute", top: "54%", left: 0, right: 0, textAlign: "center", transform: "translateY(-10%)" }}>
        <div style={{ fontFamily: fonts.mono, fontSize: numFontSize, fontWeight: 800, color: theme.text, letterSpacing: -0.5, lineHeight: 1.1 }}>
          {score}
        </div>
        <div style={{ fontFamily: fonts.body, fontSize: lblFontSize, letterSpacing: 1, color: theme.textMute, marginTop: 1, textTransform: "uppercase", fontWeight: 700 }}>
          {label}
        </div>
      </div>
    </div>
  );
}
